// journal/linkTokens — markdown ⇄ text-and-link tokens, pure. The correction
// editor shows each markdown link (`[text](/library/id)`) as one atomic chip
// between plain text, and writes the tokens back as the same markdown, so the
// author never edits link syntax by hand.

type TextToken = { readonly type: "text"; readonly text: string };
type LinkToken = {
    readonly type: "link";
    readonly label: string;
    readonly href: string;
};
export type Token = TextToken | LinkToken;

const LINK = /\[([^\]\n]+)\]\(([^)\s]+)\)/g;

export const toTokens = (markdown: string): readonly Token[] => {
    const matches = [...markdown.matchAll(LINK)];
    const { tokens, end } = matches.reduce<{
        readonly tokens: readonly Token[];
        readonly end: number;
    }>(
        (acc, m) => {
            const start = m.index ?? 0;
            const before: readonly Token[] =
                start > acc.end
                    ? [{ type: "text", text: markdown.slice(acc.end, start) }]
                    : [];
            return {
                tokens: [
                    ...acc.tokens,
                    ...before,
                    { type: "link", label: m[1] ?? "", href: m[2] ?? "" },
                ],
                end: start + m[0].length,
            };
        },
        { tokens: [], end: 0 },
    );
    return end < markdown.length
        ? [...tokens, { type: "text", text: markdown.slice(end) }]
        : tokens;
};

export const toMarkdown = (tokens: readonly Token[]): string =>
    tokens
        .map((t) => (t.type === "text" ? t.text : `[${t.label}](${t.href})`))
        .join("");
